import { Component, Element, h, Host, Prop } from '@stencil/core';
import { medalsMap } from './medals-map';
import state from '@ugc-store';
import { IBadge } from '@ugc-components/ugc-pdp-review/interface';

@Component({
  tag: 'ugc-review-badge',
  shadow: false,
})
export class UgcReviewBadge {
  @Element() el: HTMLElement;
  @Prop() reviewId: string = '';
  @Prop() badge: IBadge | null = null;

  handleMedalClick() {
    if (this.badge) {
      state.isShowMedalModal = true;
      state.medalModalData = this.badge;
    }
  }

  render() {
    if (!this.badge) return null;
    const { isDesktop } = state;

    const medalsData = medalsMap.get(this.badge.type);
    if (isDesktop)
      return (
        <ugc-tooltip
          content={
            this.badge.title && this.badge.description
              ? `<div>
            <div style="display:flex;align-items:center;">
              ${medalsData.hoverSvg}
              <span style="margin:0 4px;font-size:20px;font-weight:bold;">${this.badge.title}</span>
            </div>
            <p style="word-break:break-word;font-size:16px;margin-top:8px;line-height:24px;">${this.badge.description}</p>
          </div>`
              : ''
          }
          name={`ugc-review-badge-${this.reviewId}`}
          interactive={false}
        >
          <div
            class="flex-row-center-center relative px-8 py-2 pointer rounded-16 "
            style={{ background: medalsData.backgroundColor }}
          >
            {medalsData.icon}
            <span class="fs-12 px-2 bold" style={{ color: medalsData.color }}>
              {this.badge.name}
            </span>
          </div>
        </ugc-tooltip>
      );

    return (
      <Host>
        <div
          class="flex-row-center-center p-4 rounded-50"
          style={{ background: medalsData.backgroundColor }}
          onClick={() => this.handleMedalClick()}
        >
          {medalsData.icon}
        </div>
      </Host>
    );
  }
}
